import { defineStore } from "pinia";
import { ref, computed, watch } from "vue";
import product_data from "@/data/product-data";
import { formatUrl, averageRating } from "@/utils/utils";
import { useRoute } from "vue-router";

export const useProductFilterStore = defineStore("product_filter", () => {
  const route = useRoute();
  //const router = useRouter();
  let selectVal = ref("");

  const handleSelectFilter = (e) => {
    selectVal.value = e.value;
  };

  const maxProductPrice = Math.max(
    5_000_000,
    product_data.reduce((max, product) => {
      return product.price > max ? product.price : max;
    }, 0)
  );

  let priceValues = ref([0, maxProductPrice]);

  const handlePriceChange = (value) => {
    priceValues.value = value;
  };

  const handleResetFilter = () => {
    priceValues.value = [0, maxProductPrice];
  };

  // filteredProducts
  const filteredProducts = computed(() => {
    if (route.query.minPrice && route.query.maxPrice) {
      return product_data.filter(
        (p) =>
          p.price >= Number(route.query.minPrice) &&
          p.price <= Number(route.query.maxPrice)
      );
    } else if (route.query.category) {
      if (route.query.category === "all") {
        return product_data;
      } else {
        return product_data.filter(
          (p) => formatUrl(p.category.name) === route.query.category
        );
      }
    } else if (route.query.category_child) {
      return product_data.filter(
        (p) => formatUrl(p.category.child) === route.query.category_child
      );
    } else if (route.query.searchText) {
      return product_data.filter((p) =>
        p.title.toLowerCase().includes(route.query.searchText)
      );
    } else if (route.query.color) {
      const queryColors = route.query.color.split(",");

      return product_data.filter((p) => {
        return queryColors.some((color) =>
          p.colors && p.colors.map((c) => c.toLowerCase()).includes(color)
        );
      });
    } else if (route.query.sizes) {
      const querySizes = route.query.sizes.split(",");

      return product_data.filter((p) => {
        return querySizes.some((s) =>
          p.sizes && p.sizes.map((size) => size.toLowerCase()).includes(s)
        );
      });
    } else if (route.query.brand) {
      return product_data.filter(
        (p) => formatUrl(p.brand) === route.query.brand
      );
    } else if (route.query.rating) {
      const rating = Number(route.query.rating);
      const lowerBound = rating;
      const upperBound = rating + 1;

      return product_data.filter((p) => {
        const avgRating = averageRating(p.reviews);
        return avgRating >= lowerBound && avgRating < upperBound;
      });
    } else if (selectVal.value) {
      if (selectVal.value === "default") {
        return product_data;
      } else if (selectVal.value === "low") {
        return product_data.slice().sort((a, b) => a.price - b.price);
      } else if (selectVal.value === "high") {
        return product_data.slice().sort((a, b) => b.price - a.price);
      } else if (selectVal.value === "new") {
        return product_data.slice(-8);
      } else if (selectVal.value === "sale") {
        return product_data.filter((p) => p.discount_percentage > 0);
      } else {
        return product_data;
      }
    } else {
      return product_data;
    }
  });

  watch(
    () => route.query || route.path,
    () => {}
  );

  return {
    maxProductPrice,
    priceValues,
    handleSelectFilter,
    filteredProducts,
    handlePriceChange,
    handleResetFilter,
    selectVal,
  };
});
